import React from 'react';
import SectionsList from '../../../features/sections/SectionsList';

const ConfirmationPageSections = () => {
    return <SectionsList sectionLocation='registrationConfirmation' />;
};

export default ConfirmationPageSections;